import React from 'react';
import './style.sass';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

type ParamsType = {
    title?: string;
    leftText?: string | undefined;
    rightText?: string;
    img?: string;
    alt?: string;
    num?: string;
    pic?: string;
    picAlt?: string;
};

type CaseBlockPropsType = {
    params?: ParamsType;
    children?: any;
    className?: string;
    isBorder?: boolean;
    isTop?: boolean;
};
const CaseBlock = ({
    params,
    children,
    className = '',
    isBorder = true,
    isTop = false,
}: CaseBlockPropsType) => {
    return (
        <FullWrapper className={className}>
            <div className={isTop ? 'case-block case-block--top' : 'case-block'}>
                <div className="case-block__wrapper">
                    {params?.title && <div className="case-block__title">{params.title}</div>}
                    <div className="case-block__inner">
                        <div className="case-block__left">
                            {params?.leftText && (
                                <div dangerouslySetInnerHTML={{ __html: params.leftText }}></div>
                            )}
                            {children}
                        </div>
                        {params?.rightText && (
                            <div
                                className={
                                    isBorder
                                        ? 'case-block__right case-block__right--border'
                                        : 'case-block__right'
                                }
                            >
                                <div dangerouslySetInnerHTML={{ __html: params?.rightText }} />
                                {params.img && params.alt && (
                                    <div className="case-block__img">
                                        <img src={params.img} alt={params.alt} />
                                    </div>
                                )}
                                {params.num && <div className="case-block__num">{params.num}</div>}
                            </div>
                        )}
                    </div>
                </div>
                {params?.pic && params.picAlt && (
                    <div className="case-block__pic">
                        <img src={params.pic} alt={params.picAlt} />
                    </div>
                )}
            </div>
        </FullWrapper>
    );
};

export default CaseBlock;
